module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"hu":{"1":"Levelezési cím: ","main":"Kapcsolat"},"en":{"1":"Mailing address: ","main":"Contact"}}')
  delete Component.options._Ctor
}
